import __request__ from "routing/request";
export function getAction(sidecarId) {
  return __request__("GET", `/sidecar/action/${sidecarId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function setAction(sidecarId, JSONbody) {
  return __request__("PUT", `/sidecar/action/${sidecarId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
